import axios from "axios";
import Config from "../utils/Config";

const authService = {
  // Admin login
  login: async (credentials) => {
    try {
      const response = await axios.post(
        `${Config.API_BASE_URL}/admin/login`,
        credentials
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Forgot password - send reset email
  forgotPassword: async (email) => {
    try {
      const response = await axios.post(
        `${Config.API_BASE_URL}/admin/send/resetpassword/otp`,
        { email_or_phone: email, channel: "email" }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Verify OTP
  verifyOtp: async (email, otp) => {
    try {
      const response = await axios.post(
        `${Config.API_BASE_URL}/admin/verify-otp`,
        { email, otp }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Reset password
  resetPassword: async (email, otp, password, password_confirmation) => {
    try {
      const response = await axios.post(
        `${Config.API_BASE_URL}/admin/reset-password`,
        {
          email,
          otp,
          password,
          password_confirmation,
        }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get current admin user
  getCurrentUser: async () => {
    try {
      const token = localStorage.getItem(Config.TOKEN_KEY);
      const response = await axios.get(`${Config.API_BASE_URL}/admin/profile`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Logout
  logout: async () => {
    try {
      const token = localStorage.getItem(Config.TOKEN_KEY);
      const response = await axios.post(
        `${Config.API_BASE_URL}/admin/logout`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      localStorage.removeItem(Config.TOKEN_KEY);
      localStorage.removeItem(Config.USER_KEY);
      return response.data;
    } catch (error) {
      // Even if logout fails, clear local storage
      localStorage.removeItem(Config.TOKEN_KEY);
      localStorage.removeItem(Config.USER_KEY);
      throw error.response?.data || error.message;
    }
  },
};

export default authService;
